import React,{ useRef, useEffect, useState } from "react";
import SwipeVM from "./SwipeVM";
import ImageryLayer from "@arcgis/core/layers/ImageryLayer";

const SwipeWidget = ({view,activeWidget}) => {
    const swipeWidgetDiv = useRef(null);
    const swipeWidget = useRef(null);
    const swipeButton = useRef(null);
    const swipeMapChange = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (activeWidget === "swipeWidget") {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [activeWidget]);

    let style = { display: "flex", borderWidth:'0px' };
      if (visible) {
        style.display = "flex";
      } else {
        style.display = "none";
      }


    useEffect(() => {
        if (swipeWidgetDiv.current) {
            SwipeVM(view,swipeWidgetDiv.current)
            .then(widget=>{
                swipeWidget.current = widget;

                const eagle2021 = new ImageryLayer({
                    url: "https://www.ocgis.com/arcpub/rest/services/Aerial_Imagery_Countywide/Eagle_Aerial_2021_OC_1FT_sid/ImageServer",
                    listMode: "hide",
                    visible: false
                });
                //view.map.add(eagle2021);
               
               //const swipeButton = document.getElementById('Swipe Button');
                view.ui.add(swipeButton.current, "top-left");
                //const swipeMapChange = document.getElementById('Change Map Button');
                
                swipeButton.current.addEventListener("click", () => {
                    if(swipeWidget.current.view){
                        swipeWidget.current.view = null;
                        view.ui.remove(swipeWidget.current)
                        view.ui.remove(swipeMapChange)
                    }else{
                        swipeWidget.current.view = view;
                        view.ui.add(swipeWidget.current)
                        //view.ui.add(swipeMapChange, "top-right")
                    }
                });

                swipeMapChange.current.addEventListener("click", () => {
                    //let trailingLyr=view.ui._components.filter((comp)=>comp.id==="basemapToggle").nextBasemap
                    //let trailingLyr = view.ui.find("basemapToggle")
                    //view.map.add(eagle2021)
                    //reactiveUtils.when
                    //view.map.allLayers.filter((lyr)=>lyr.type!=='elevation' && lyr.type!=='tile')
                    //eagle2021.visible = true
                    //swipeWidget.trailingLayers = [eagle2021]
                    //swipeWidget.leadingLayers = testj
                    // swipeWidget.trailingLayers = [trailingLyr["nextBasemap"].baseLayers._items[1]]
                });
            })

            return () => {
                swipeWidget.current.destroy();
            }
        }
    }, []);
    
    return(
        <div ref={swipeWidgetDiv} style={style} >
            <button ref={swipeButton} id="Swipe Button" 
                className="esri-widget--button esri-interactive esri-icon-swap" 
                title="Quick Swipe" style={{borderWidth:'0px',padding:'20px'}}>
            </button>
            <button ref={swipeMapChange} id="Change Map Button" 
                className="esri-widget--button esri-interactive esri-icon-collection" 
                title="Change Trailing Map">
            </button>
        </div>
    )
};

export default SwipeWidget;